export class DsnOperationMail {
  public id?: number;
  public clusterId?: number;
  public clusterDescription?: string;
  public serviceId?: number;
  public serviceName?:string;
  public divisionSalesNetworkId?: number;
  public salesNetworkId?: number;
  public divSalesName?:string;
  public email?: string
  public operationPid?: number
  public paramCode?: number
  public paramDescription?: string
  public clusterCode?:string
}


// WEBPACK FOOTER //
// ./src/app/models/dsn-operation-mail.model.ts